// bao migrate skip
import TabPage from "./../../factories/tab-page";
import "./../../bindings/bao-number-box";
import "./../../bindings/bao-searcher";
import BaseViewModel from "./../../factories/base-view-model2";
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import BaoDialog from "./../../factories/bao-dialog";
class UniversalFieldDataType {
    Decimals: KnockoutObservable<number>;
    YesNoPositiveText: KnockoutObservable<string>;
    YesNoNegativeText: KnockoutObservable<string>;
    YesNoPositiveCss: KnockoutObservable<string>;
    YesNoNegativeCss: KnockoutObservable<string>;
    CsvOptions = ko.observable("");
    CsvOptionsBold = ko.observable(false);
    CsvOptionsUnderlined = ko.observable(false);
    CsvOptionsHeading = ko.observable(false);
    CsvOptionsItalic = ko.observable(false);
    CsvOptionsIsDeselectable = ko.observable(false);
    UniversalField = ko.observable();
    DateTimePickerValue: KnockoutObservable<string> = ko.observable("");
    ViewModel = ko.observable();
    tabPage: TabPage;
    UniversalFieldTypeId: KnockoutObservable<string>;
    UniversalFieldTypeName = ko.observable("");
    UniversalFieldType = ko.observable("");
    Unit = ko.observable("");
    constructor(public TabPage: TabPage, parent: any) {
        this.tabPage = TabPage;
        this.ViewModel = parent;        
    }
    /**
     * Liefert true wenn der gewählte TagType numerisch ist.
     * Muss im JS stattfinden, wegen der möglichkeit am Client den Typ zu ändern
     */
    TagTypeIsNumeric = ko.pureComputed(() => {
        return Boolean(typeof this.UniversalFieldTypeId === "function" && this.UniversalFieldTypeId() === '1eb0ef5b-07bd-476c-8415-d32931cd6bca');
    });
    /**
     * Liefert true wenn der gewählte TagType YesNo ist
     * Muss im JS stattfinden, wegen der möglichkeit am Client den Typ zu ändern
     */
    TagTypeIsYesNo = ko.pureComputed(() => {
        return Boolean(typeof this.UniversalFieldTypeId === "function" && this.UniversalFieldTypeId() === '6c4865b4-3e87-4f64-be09-9e461e88550a');
    });
    /**
     * Liefert true wenn der gewählte TagType Caption ist
     * Muss im JS stattfinden, wegen der möglichkeit am Client den Typ zu ändern
     */
    TagTypeIsCaption = ko.pureComputed(() => {
        return Boolean(typeof this.UniversalFieldTypeId === "function" && this.UniversalFieldTypeId() === '81c0785b-98b9-45ea-b260-6c6076d5ba3f');
    });
    /**
     * Liefert true wenn der gewählte TagType nicht Caption ist
     * Muss im JS stattfinden, wegen der möglichkeit am Client den Typ zu ändern
     */
    TagTypeIsNotCaption = ko.pureComputed(() => {
        return Boolean(typeof this.UniversalFieldTypeId === "function" && this.UniversalFieldTypeId() !== '81c0785b-98b9-45ea-b260-6c6076d5ba3f');
    });
    /**
     * Liefert true wenn der gewählte TagType RadioButtons ist
     * Muss im JS stattfinden, wegen der möglichkeit am Client den Typ zu ändern
     */
    TagTypeIsRadioButtons = ko.pureComputed(() => {
        return Boolean(typeof this.UniversalFieldTypeId === "function" && (this.UniversalFieldTypeId() === 'b3f7d21b-56dc-4258-91ba-00f0d64cb2b2'
            ||
            this.UniversalFieldTypeId() === '02dd5bf9-f182-4368-917e-dd053ee2f4a7'));
    });
    TagTypeNeedsCsvOptions = ko.pureComputed(() => {
        return Boolean(typeof this.UniversalFieldTypeId === "function" && (this.UniversalFieldTypeId() === 'b3f7d21b-56dc-4258-91ba-00f0d64cb2b2' //Radio Buttons
            ||
            this.UniversalFieldTypeId() === '02dd5bf9-f182-4368-917e-dd053ee2f4a7' //Combobox
            ||
            this.UniversalFieldTypeId() === '0fc89eed-9510-4094-a0a8-835cee0a3f24' //=BaoSearcher
        ));
    });
    /**
    * Liefert true wenn der gewählte TagType nicht Platzhalter oder Platzhalter (Linie) ist
    * Muss im JS stattfinden, wegen der möglichkeit, am Client den Typ zu ändern
    */
    TagTypeIsNotCaptionNorPlaceholder = ko.pureComputed(() => {
        let returnValue = Boolean(typeof this.UniversalFieldTypeId === "function" &&
            this.UniversalFieldTypeId() !== '6f5ad806-d399-4bb5-8417-567041b9ecc6'
            && this.UniversalFieldTypeId() !== '80282140-301b-4c8a-8144-e4be45f2de43'
            && this.UniversalFieldTypeId() !== '81c0785b-98b9-45ea-b260-6c6076d5ba3f');
        this.UniversalField["TagTypeIsNotCaptionNorPlaceholder"](returnValue);
        return returnValue;
    });
    /**
    * Liefert true wenn der gewählte TagType Datum/Zeitauswahl ist
    * Muss im JS stattfinden, wegen der möglichkeit, am Client den Typ zu ändern
    */
    TagTypeIsDateTimePicker = ko.pureComputed(() => {
        return Boolean(typeof this.UniversalFieldTypeId === "function" && this.UniversalFieldTypeId() === 'e2a64241-6766-4159-81d7-257da36327bb');
    });
    /**
    * Liefert true wenn der gewählte TagType TextArea ist
    * Muss im JS stattfinden, wegen der möglichkeit, am Client den Typ zu ändern
    */
    TagTypeIsTextArea = ko.pureComputed(() => {
        return Boolean(typeof this.UniversalFieldTypeId === "function" && this.UniversalFieldTypeId() === 'b453e0de-0f88-4f22-bfff-a0189f6a117b');
    });
    /**
    * Liefert true wenn der gewählte TagType Suchdialog mit Suchobjekt (BaoSearcherWithObject) ist
    * Muss im JS stattfinden, wegen der möglichkeit, am Client den Typ zu ändern
    */
    TagTypeIsBaoSearcherWithObject = ko.pureComputed(() => {
        return Boolean(typeof this.UniversalFieldTypeId === "function" && this.UniversalFieldTypeId() === '8de0ffb8-1250-4322-85ee-2a64c46bbb78');
    });
    DecimalsCalc = ko.pureComputed(() => {
        var decimals = ko.unwrap(this.Decimals);
        return decimals == null ? 0 : decimals;
    });
    ItemCompleteCheck(item: any): JQueryPromise<boolean> {
        let def = $.Deferred<boolean>();
        var isComplete = true;
        if (Bao.Utils.String.IsNullOrEmpty(this.UniversalFieldTypeId())) {
            isComplete = false;
        }
        if (this.TagTypeIsRadioButtons() &&
            Bao.Utils.String.IsNullOrEmpty(ko.unwrap(this.CsvOptions))) {
            isComplete = false;
        }
        if (this.TagTypeIsYesNo() &&
            (Bao.Utils.String.IsNullOrEmpty(ko.unwrap(this.YesNoPositiveText)) ||
                Bao.Utils.String.IsNullOrEmpty(ko.unwrap(this.YesNoNegativeText)))) {
            isComplete = false;
        }
        if (!isComplete) {
            new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        // Nicht mehr als 100 Zeilen für die TextArea  
        if (this.TagTypeIsTextArea() && isComplete) {
            let value = parseInt(ko.unwrap(this.CsvOptions));
            if (value != null && (value < 1 || value > 100 || isNaN(value))) {
                new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgLessRows"), "info");
                isComplete = false;
            }
            
        }
        def.resolve(isComplete);
        return def.promise();
    }
    InitUrl() {
        return "UniversalField/Init";
    }
}
export default UniversalFieldDataType;